import { useMutation } from "@apollo/client";

import { gql } from "~/__generated__";
import useDestructiveActionBlocker from "~/modules/app/hooks/useDestructiveActionBlocker";

import { PROJECT_EXPORT_GET_ALL } from "./useProjectExports";

const ProjectExportDeleteMutation = gql(`
    mutation ProjectExportDelete($input: GqlProjectExportDeleteInput!) {
        projectExportDelete(input: $input)
    }
`);

export function useProjectExportDelete() {
    const [deleteProjectExportAsync, { loading }] = useMutation(ProjectExportDeleteMutation, {
        refetchQueries: [PROJECT_EXPORT_GET_ALL],
    });

    const blocker = useDestructiveActionBlocker(async (projectExportId: string) => {
        await deleteProjectExportAsync({ variables: { input: { projectExportId } } });
    });

    return {
        blocker,
        loading,
        deleteProjectExport: blocker.onAction,
    };
}
